import React from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CategoryTags from './CategoryTags';
import { QuoteStatusPill } from './QuoteStatus';
import { fmtDate } from '../../utils/format';

const headSx = { fontWeight: 700, fontSize: 11, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: 0.6, py: 1.5, bgcolor: '#F8FAFC', borderBottom: '1px solid #EEF2F6' };

export default function QuotesTable({ quotes, total, page, size, onPage, onSize, hideClient }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Paper elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: '14px', overflow: 'hidden' }}>
            <TableContainer>
                <Table sx={{ minWidth: 640 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={headSx}>{t('quotes.columns.quote')}</TableCell>
                            {!hideClient && <TableCell sx={headSx}>{t('jobs.columns.client')}</TableCell>}
                            <TableCell sx={headSx}>{t('quotes.fields.categories')}</TableCell>
                            <TableCell sx={headSx}>{t('jobs.columns.status')}</TableCell>
                            <TableCell sx={headSx}>{t('quotes.columns.date')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {quotes.map(q => (
                            <TableRow key={q.id} hover onClick={() => navigate(`/quotes/${q.id}`)} sx={{ cursor: 'pointer', '&:last-child td': { border: 0 } }}>
                                <TableCell sx={{ py: 1.25, maxWidth: 320 }}>
                                    <Typography noWrap sx={{ fontWeight: 700, color: '#0F172A', fontSize: 13.5 }}>{q.title}</Typography>
                                    <Typography noWrap sx={{ fontSize: 12, color: '#94A3B8' }}>{q.number}</Typography>
                                </TableCell>
                                {!hideClient && <TableCell sx={{ fontSize: 13, color: '#475569' }}>{q.client?.name}</TableCell>}
                                <TableCell><CategoryTags categories={q.categories} max={2} /></TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                        <QuoteStatusPill status={q.status} size="sm" />
                                        {q.jobs.length > 0 && <WorkOutlineIcon titleAccess={t('quotes.jobs.count', { count: q.jobs.length })} sx={{ fontSize: 16, color: '#10B981' }} />}
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ fontSize: 13, color: '#64748B', whiteSpace: 'nowrap' }}>{fmtDate(q.createdAt)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {onPage && (
                <TablePagination component="div" count={total} page={page} rowsPerPage={size}
                                 onPageChange={(_, p) => onPage(p)} onRowsPerPageChange={(e) => onSize(parseInt(e.target.value, 10))}
                                 rowsPerPageOptions={[10, 25, 50, 100]} sx={{ borderTop: '1px solid #F1F5F9' }} />
            )}
        </Paper>
    );
}
